import { render } from "./CreateBuyRequest.vue?vue&type=template&id=65628004&scoped=true"
import script from "./CreateBuyRequest.vue?vue&type=script&lang=js"
export * from "./CreateBuyRequest.vue?vue&type=script&lang=js"

import "./CreateBuyRequest.vue?vue&type=style&index=0&id=65628004&lang=css"
import "./CreateBuyRequest.vue?vue&type=style&index=1&id=65628004&lang=css"
import "./CreateBuyRequest.vue?vue&type=style&index=2&id=65628004&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65628004"]])

export default __exports__